export type ConnectablePlatformInfo = {
    iconUrl: string;
    name: string;
    description: string;
    /** Where in the user's data is this connection's profile at, e.g 'discordProfile' */
    profilePath: string;
}

import PatreonLogo from "@/assets/third_party/logos/patreon_logo.svg";
import DiscordLogo from "@/assets/third_party/logos/discord_logo.svg";

export const connectablePlatforms: ConnectablePlatformInfo[] = [
    {
        iconUrl: DiscordLogo.src,
        name: "discord",
        description:
            "Connecting your Discord account enables Alfred to serve you properly with his core features." +
            "It also allows Alfred to serve you directly within Discord. Connect now to unlock my full range of butler services.",
        profilePath: "discordProfile",
    },
    {
        iconUrl: PatreonLogo.src,
        name: "patreon",
        description:
            "Connect your Patreon account to allow Alfred to see and understand your subscription so that personalized experience can be delivered to your tier.",
        profilePath: "patreonProfile",
    },
];

export function getConnectablePlatform(name: "patreon" | "discord") {
    return connectablePlatforms.find((platform) => platform.name === name)!;
}